module.exports = __webpack_public_path__ + "static/thumbnail-6082078478575687915079a701ba3a37.png";